import * as mgm from '../services/mgm';

export default {
  namespace: 'mgm',

  state: {},

  effects: {
    *getQueryActivityMgmList(_, { call, put }) {
      const mgmList = yield call(mgm.getQueryActivityMgmList, { code: '' });

      yield put({
        type: 'save',
        payload: {
          mgmList,
        },
      });
    },
    *exportActivityDetail({ payload: { code }, callback }, { call }) {
      console.log({ code });
      const res = yield call(mgm.exportActivityDetail, { code });
      if (res.code === 0) {
        return callback();
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
